import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeedCard = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'recommendation':
        return { name: 'FileText', color: 'var(--color-primary)' };
      case 'approval':
        return { name: 'CheckCircle2', color: 'var(--color-success)' };
      case 'credit':
        return { name: 'Coins', color: 'var(--color-accent)' };
      case 'subscription':
        return { name: 'Crown', color: 'var(--color-warning)' };
      default:
        return { name: 'Info', color: 'var(--color-muted-foreground)' };
    }
  };

  return (
    <div className="clinical-card p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Activity" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
      </div>
      <div className="space-y-3">
        {activities?.map((activity) => {
          const icon = getActivityIcon(activity?.type);
          return (
            <div key={activity?.id} className="flex items-start gap-3 pb-3 border-b border-border last:border-0 last:pb-0">
              <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name={icon?.name} size={14} color={icon?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground mb-1">{activity?.message}</p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon name="Clock" size={10} />
                  <span>{activity?.timestamp}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityFeedCard;